import React, {useState, useEffect} from "react";
import MainTable from "../components/MainTable";
import {PerformanceAddBox, ConfirmBox} from "../components/PerformanceAddBox";
import {useUser} from "../context/UserContext";
import PerformanceHooks from "../hooks/PerformanceHooks";


function PerformanceTeam() {
  const typeKeyKor = "팀원관리";
  const typeKey = "employments";
  const mainTitle = "팀원관리 리스트";
  const addBoxTitle = "팀원 관리";

  const {authority, company} = useUser();

  let newDataTitles = [
    { key: "_id", label: "", type: "_id", req: false, tableShow: true, searchable: false },
    { key: "startup_name", label: "입주사명", type: "company", req: true, tableShow: true },
    { key: "hire_date", label: "입사년월", type: "date", req: true, tableShow: true},
    { key: "birth_date", label: "출생년도", type: "date", req: false, tableShow: true},
    { key: "guarantee", label: "4대보험유무", type: "select", req: true, options: ["유", "무"],
      tableShow: true,
    },
    { key: "email", label: "이메일", type: "text", req: false, tableShow: false, searchable: false },
    // { key: "education", label: "졸업 학교", type: "text", req: false, tableShow: false},

    { key: "name", label: "성명", type: "text", req: true, tableShow: true },
    { key: "sex", label: "성별", type: "select", req: true, tableShow: true, options: ["남", "여"]},
    { key: "role", label: "직책", type: "select", 
      options: ["단독대표", "공동대표", "사외이사", "사내이사", "비정규직원", "정규직원", "기타", "인턴",
        // "과장", "대리", "사원",   
      ],
      req: true, tableShow: true },
    { key: `phone_nb`, label: "연락처", type: "text", req: false, tableShow: false, searchable: false },
    { key: `quit_date`, label: "탈퇴일", type: "date", req: false, tableShow: true },
    { key: "file_name", label: "첨부파일", type: "file", req: false, tableShow: false, searchable:false } // 숨김 처리
  ];
    

  const { data, loading, setFilteredData, downloadFilteredData,
    headTitles, isModalOpen, setIsModalOpen, selectedRow, openModal, closeModal,
    handleDelete, handleSave, actionMenuItems, handleActionMenuClick, selectedData } =
    PerformanceHooks(typeKey, typeKeyKor, newDataTitles);

  const handleNewEntry = () => {
    // console.log("매출관리 신규 작성 버튼 클릭됨!");
    setIsModalOpen("new");
  };
  //신규 작성 파트 (파트별 변경 필요)
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [Performance] newPerformanceEntry_performance_${typeKey} 감지됨!`);
      handleNewEntry();
    };

    window.addEventListener(`newPerformanceEntry_${typeKey}`, eventHandler);
    return () => {
      console.log("⚪ [Performance] 이벤트 리스너 제거됨");
      window.removeEventListener(`newPerformanceEntry_${typeKey}`, eventHandler);
    };
  }, []);

  const handleNewEntry2 = () => {
    downloadFilteredData();
  };

  //신규 작성 파트 (파트별 변경 필요)
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [Performance] newPerformanceEntry_performance_${typeKey}2 감지됨!`);
      handleNewEntry2();
    };

    window.addEventListener(`newPerformanceEntry_${typeKey}2`, eventHandler);
    return () => {
      console.log("⚪ [Performance] 이벤트 리스너 제거됨");
      window.removeEventListener(`newPerformanceEntry_${typeKey}2`, eventHandler);
    };
  }, []);

  if(authority === 3 || authority === 2 || authority === 4){
    newDataTitles = newDataTitles.map(field =>
      field.label === "입주사명" ? {...field, value: company} : field
    );
  }

  return (
    <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
        <MainTable title={mainTitle} tableHeadTitles={headTitles} tableData={data}
          onActionMenuClick={handleActionMenuClick} actionMenuItems={actionMenuItems}
          pageType={'performance'} dateFilterBase={`hire_date`} setUpperData={setFilteredData} performanceType={typeKey}
          mainSearchKey="startup_name"/>
        {/* 모달 렌더링 */}
        {isModalOpen && (() => {
          switch (isModalOpen) {
            case "new":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} onSave={handleSave}
                boxTitle={addBoxTitle}/>;
            case "edit":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} 
                onSave={handleSave} data={selectedData}
                fixOrNot = {true} onDelete ={handleDelete} boxTitle={addBoxTitle}/>;
            case "detail":
              return <PerformanceAddBox onClose={closeModal} dataTitles={newDataTitles} onSave={handleSave}
                data={selectedData} onDelete={handleDelete} boxTitle={addBoxTitle}/>;
            case "delete":
              return (
                <ConfirmBox
                  head="정말 삭제하시겠습니까?"
                  describe="삭제된 데이터는 복구할 수 없습니다."
                  btn1Text="예"
                  btn1Main={false}
                  btn1Action={() => handleDelete(selectedRow)}
                  btn2Text="아니오"
                  btn2Action={closeModal}
                  onClose={closeModal}
                />
              );
            default:
              return null;
          }
        })()}
        </>            
      )}
    </div>
  );
  // return <MainTable title="팀원관리 리스트" tableHeadTitles={headTitles} tableData={data} 
  //   pageType={'performance'}/>;
}

export default PerformanceTeam;